import { render } from "./LogoSvg.vue?vue&type=template&id=bc3ad3e2"
import script from "./LogoSvg.vue?vue&type=script&lang=js"
export * from "./LogoSvg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\CONSULT\\PROJECTS\\_HTML\\baden-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__